import { Component } from '@angular/core';
import { Router, UrlSerializer } from '@angular/router';
import { ITableCellItem } from 'app/main/shared/shared/table/table-cell';
import { ITableColumn } from 'app/main/shared/shared/table/table-column';
import { IContractCardsSummaryEntity, IDocumentsMatching } from '../match-contract-cards-step.component';

@Component({
  selector: 'app-cc-documents-bulk-upload-column',
  standalone: true,
  imports: [],
  templateUrl: './cc-documents-bulk-upload-column.component.html',
  styleUrls: ['./cc-documents-bulk-upload-column.component.scss']
})
export class CcDocumentsBulkUploadColumnComponent implements ITableCellItem{
  readonly DOCUMENT_DETAILS_URL ="sender";

  dataItem: IContractCardsSummaryEntity;
  columnOptions: ITableColumn<unknown>;

  get documents():IDocumentsMatching[]{
    return this.dataItem && this.columnOptions?.field && Array.isArray(this.dataItem[this.columnOptions.field])
    ? this.dataItem[this.columnOptions.field]
    :[]
  }

  constructor(private router: Router, private serializer: UrlSerializer) {}

  navigateToDocumentDetails(document: IDocumentsMatching):void{

    if(document?.role_id && document?.unique_id){
      const tree = this.router.createUrlTree([this.DOCUMENT_DETAILS_URL,  document.role_id, document.unique_id]);
      window.open(`#${this.serializer.serialize(tree)}`, '_blank');
    }
  }

}
